/**
 * Readout — VFO/multimeter-style numeric display.
 *
 * Layout:
 *   [LABEL]
 *   [VALUE]   [UNIT]
 *
 * tone: 'default' | 'accent' | 'ok' | 'warn' | 'error'
 */
export type ReadoutTone = 'default' | 'accent' | 'ok' | 'warn' | 'error';

export class Readout {
  readonly el: HTMLDivElement;
  private valueEl: HTMLSpanElement;
  private unitEl: HTMLSpanElement;
  private labelEl: HTMLSpanElement;

  constructor(label: string, value: string = '—', unit: string = '') {
    this.el = document.createElement('div');
    this.el.className = 'readout';

    this.labelEl = document.createElement('span');
    this.labelEl.className = 'readout__label';
    this.labelEl.textContent = label;

    const valWrap = document.createElement('div');
    valWrap.className = 'readout__value-row';

    this.valueEl = document.createElement('span');
    this.valueEl.className = 'readout__value';
    this.valueEl.textContent = value;

    this.unitEl = document.createElement('span');
    this.unitEl.className = 'readout__unit';
    this.unitEl.textContent = unit;

    valWrap.appendChild(this.valueEl);
    if (unit) valWrap.appendChild(this.unitEl);

    this.el.appendChild(this.labelEl);
    this.el.appendChild(valWrap);
  }

  setValue(value: string, unit?: string): void {
    this.valueEl.textContent = value;
    if (unit !== undefined) this.unitEl.textContent = unit;
  }

  setTone(tone: ReadoutTone): void {
    this.el.dataset.tone = tone;
  }

  setLabel(label: string): void {
    this.labelEl.textContent = label;
  }
}
